import styled from "styled-components";

// CUSTOMERFORM

export const FormSection = styled.div`
  width: 100%;
  padding-top: 1rem;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: ${p =>
    p.gtc ? p.gtc : `repeat(${p.items || 1}, 1fr)`};
  grid-gap: 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
